import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import {Controlled as CodeMirror} from 'react-codemirror2'


import parseText from '../../pattern_utilities/parseText'
import { pmUpdateFromText, pmUpdateFromHybrid, showTooltip, hideTooltip } from '../../actions/actions.export.js';

import Button from '../Button/Button.js'
import canI from '../../canI.js';

import './SuperEditor.css';

require('codemirror/addon/mode/simple.js');
require('./codemirror-pat.js');
require('codemirror/lib/codemirror.css');

var superEditorTimeout;


class SuperEditor extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      isHovering: false,
      blockChange: false,
      value: props.patternManager.cache[props.cacheID].text
    }

    this.handleChange = this.handleChange.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  handleChange(value){
    if(this.state.blockChange){
      return this.setState({
        blockChange: false
      });
    } 

    const { dispatch, cacheID, patternManager } = this.props; 
    clearTimeout(superEditorTimeout);
    superEditorTimeout = setTimeout(function(){
      
      dispatch(pmUpdateFromText({
        pattern: parseText(value),
        sendToServer: patternManager.cache[cacheID].linkedToServer,
        cacheID: cacheID,
        regenText: false
      }));
    }, 250);
  }

  toggle(i, val){
    const { dispatch, patternManager, cacheID } = this.props;
    
    var rows = JSON.parse(JSON.stringify(patternManager.cache[cacheID].rows));

    i = parseInt(i, 10);
    var r;

    if(i === -1){
      var falseAlreadyCounter = 0;
      for(r in rows){
        if(!rows[r][val]) falseAlreadyCounter++;
        rows[r][val] = false;
      }
      if(falseAlreadyCounter === rows.length){
        for(r in rows){
          rows[r][val] = true;
        }
      }
    } else if(i !== undefined){
      if(rows[i][val] === undefined){
        rows[i][val] = true;
      } else {
        rows[i][val] = !rows[i][val];
      }
    }

    dispatch(pmUpdateFromHybrid({
      cacheID: cacheID,
      pattern: {
        rows: rows
      }
    }))
  }

  componentWillReceiveProps(newprops){
    if(this.state.value !== newprops.patternManager.cache[newprops.cacheID].text){
      this.setState({
        value: newprops.patternManager.cache[newprops.cacheID].text,
        blockChange: true
      })
    }
  }

  render(){

    const { dispatch, cacheID, patternManager, globalReducer, team, user } = this.props; 

    var pattern = patternManager.cache[cacheID];

    var marker;

    var lines = pattern.text.split('\n');
    var index = 0;
    for(var i in lines){
      if(lines[i].indexOf(';angle') === 0){
        lines[i] = {headerRow: true}
      } else if(lines[i][0] === '*' || lines[i][0] === ';' || lines[i][0] === ' ' || lines[i].trim() === ''){
        lines[i] = {skip: true}
      } else {
        lines[i] = {index: index}
        index++;
      }
    }

    var rows = patternManager.cache[cacheID].rows;

    var has_errors_somewhere = false;
    var error_counter = 0;
    for(var i in rows){
      if(rows[i].errors){
        if(rows[i].errors.length > 0){
          has_errors_somewhere = true;
          error_counter++;
        }
      }
    }
   
    return (
      <div className="super-editor">
        <div className="super-editor-inner">
        
          <div className="super-editor-gutter">
            {
              lines.map((l, i) => {
                var isBold = false;
                var isInvisible = false;
                var isGreyscale = false;
                var errors = [];
                var original_index = false;

                if(rows[l.index] !== undefined){
                  isBold = rows[l.index]['bold'];
                  isInvisible = rows[l.index]['invisible'];
                  isGreyscale = rows[l.index]['greyscale'];
                  original_index = rows[l.index].original_index;
                  errors = rows[l.index].errors || [];
                }

                if(l.headerRow && has_errors_somewhere){
                  if(error_counter === 1){
                    errors = ["One row has an error."];
                  } else {
                    errors = ["This file has " + error_counter + " lines with errors and may not import properly."];
                  }
                }

                return <div key={i} className="super-editor-gutter-line">
                  {
                    l.skip ? <span>&nbsp;</span>
                    :
                    <div className="super-editor-gutter-icons">
                      {
                        canI(user, team, 'text_editor_pro_tools', team.current) && 
                        <i 
                          className={"fa-fw super-editor-gutter-icon " + (l.headerRow || !isInvisible ? "fas fa-eye" : "far fa-eye-slash")  + (!isInvisible ? " super-editor-gutter-icon-active" : "")}
                          onClick={(e)=>{ this.toggle(l.headerRow ? -1 : l.index, 'invisible')} }
                          />
                      }
                      {
                        canI(user, team, 'text_editor_pro_tools', team.current) && 
                        <i 
                          className={"fa-fw super-editor-gutter-icon " + ((l.headerRow || isBold) ? "fas" : "far") + " fa-star " + (isBold ? "super-editor-gutter-icon-active" : "")}
                          onClick={(e)=>{ this.toggle(l.headerRow ? -1 : l.index, 'bold')} }
                          />
                      }
                      {
                        globalReducer.colors && 
                        <i 
                          className={"fa-fw super-editor-gutter-icon " + ((l.headerRow || !isGreyscale) ? "fas fa-tint" : "far fa-tint-slash") + " text_" + ((parseInt(original_index, 10) * 3) % 11) + (isGreyscale ? " super-editor-gutter-icon-greyscale" : "")}                          
                          onClick={(e)=>{ this.toggle(l.headerRow ? -1 : l.index, 'greyscale')} }
                          />
                      }
                      {
                        errors.length > 0 ? 
                          <i 
                            className={"fa-fw super-editor-gutter-icon super-editor-gutter-icon-nonclickable text-danger fas " + (l.headerRow ? "fa-exclamation-circle" : "fa-exclamation")}
                            onMouseEnter={(e)=> { 
                              dispatch(showTooltip({
                                e: e,
                                position: 'left', 
                                lag: 150,
                                nobr: false,
                                content: <div style={{width: 200}} className="multi-error-tooltip">
                                  {
                                    errors.map((err, j)=>{
                                      return <p key={j}>{err}</p>
                                    })
                                  }
                                </div>
                              }))  
                            }}
                            onMouseLeave={(e)=>{ dispatch(hideTooltip()) }}
                            />
                          :
                          <i 
                            className={"fa-fw super-editor-gutter-icon super-editor-gutter-icon-nonclickable fas text-success " + (l.headerRow ? "fa-check-circle" : "fa-check")}
                            onMouseEnter={(e)=> { 
                                dispatch(showTooltip({
                                  e: e,
                                  position: 'left', 
                                  lag: 150,
                                  nobr: false,
                                  content: <span>No errors.</span>
                                }))  
                            }}
                            onMouseLeave={(e)=>{ dispatch(hideTooltip()) }}
                            />
                      }
                    </div>
                  }
                </div>
              })
            }
          </div>
          
          <div className={"super-editor-cm-wrapper " + (pattern.mode !== 'raster' ? "super-editor-disabled" : "") + ((!user.isLoggedIn && pattern.mode !== 'raster') ? " super-editor-locked" : "")}>
            <CodeMirror
              value={this.state.value}
              options={{
                mode: 'pat',
                lineNumbers: true,
                height: 'auto',
                disabled: pattern.mode !== 'raster'
              }}
              onBeforeChange={(editor, data, value) => {
                if(pattern.mode !== 'raster') return;
                this.setState({value});
              }}
              onChange={(editor, data, value) => {
                if(pattern.mode !== 'raster') return;
                this.handleChange(value);
              }}
              onCursorActivity={(cm) => {
                if(pattern.mode !== 'raster') return;
                if(marker) marker.clear();
                
                var cursor = cm.getCursor()
                var token = cm.getTokenAt(cursor);
                var line = cm.getCursor().line;
                var start = token.start;
                var end = token.end;

                marker = cm.markText({line: line, ch: start}, {line: line, ch: end}, {
                  className: "cm-current"
                })
              }}
            />
          </div>
        </div>
      </div>
    )
  }
}

SuperEditor = connect((state, ownProps) => {
  const { patternManager, globalReducer, team, user } = state;

  return {
    patternManager,
    globalReducer,
    team,
    user,
    state
  }
})(SuperEditor);


export default SuperEditor;


// WEBPACK FOOTER //
// ./src/components/SuperEditor/SuperEditor.js